import { Navigate } from 'react-router-dom'

import { useAuth } from '../context/AuthContext'

export function LoginPage() {
  const { status, signIn } = useAuth()

  if (status === 'authenticated') return <Navigate to="/" replace />

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 px-6">
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl">
        <button
          type="button"
          onClick={() => {
            void signIn()
          }}
          className="btn-primary w-full justify-center gap-2"
          disabled={status === 'loading'}
        >
          <GoogleGlyph />
          {status === 'loading' ? 'Loading…' : 'Continue with Google'}
        </button>
      </div>
    </div>
  )
}

function GoogleGlyph() {
  return (
    <svg className="h-4 w-4" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#FFC107"
        d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 8 3l5.7-5.7C33.7 5.7 29 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z"
      />
      <path
        fill="#FF3D00"
        d="M6.3 14.1l6.6 4.8C14.7 16 19 13 24 13c3 0 5.8 1.1 8 3l5.7-5.7C33.7 7.5 29 5.8 24 5.8c-7.7 0-14.4 4.4-17.7 8.3z"
      />
      <path
        fill="#4CAF50"
        d="M24 44c5 0 9.6-1.9 13-5.1l-6-5.1c-2 1.4-4.5 2.2-7 2.2-5.3 0-9.7-3.4-11.3-8.1l-6.5 5C9.5 39.6 16.2 44 24 44z"
      />
      <path
        fill="#1976D2"
        d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.2-4 5.6l6 5.1C40 35 44 30 44 24c0-1.2-.1-2.4-.4-3.5z"
      />
    </svg>
  )
}
